export const DEFAULT_FORM_DATA = {
	location_from: '1',
	location_to: '1',
}
